module.exports = __webpack_public_path__ + "static/media/F.F. 3D PLAN.6641e438.jpg";